// extracted by mini-css-extract-plugin
module.exports = {"root":"why-free_root__3cMcw","outer":"why-free_outer__14LYH","inner":"why-free_inner__2EyFp"};